import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function SchedulerRoundRobinFeatureGate(props: Props) {
    const {isOpen, onClose} = props;

    return (
        <FeatureGateModalWrapper
            title='Upgrade to unlock round-robin'
            description='Streamline your team’s scheduling process with round-robin meetings.'
            bullets={[
                'Ensure meetings are seamlessly assigned to the next available team member.',
                'Optimize workloads by balancing meeting distribution across your team.',
                'Provide quick responses by connecting customers with team members faster.',
            ]}
            feature='roundRobinScheduler'
            isOpen={isOpen}
            onClose={onClose}
        />
    );
}
